import React from "react";

import Divider from "@material-ui/core/Divider";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// icons
import ActionCancel from "@material-ui/icons/Cancel";

import { TextInput, SelectArrayInput, PageFooter, SaveButton, Button, required } from "jazasoft";
import SimpleForm from "jazasoft/lib/mui/form/SimpleForm";

import { inputOptions } from "../../../../utils/helpers";

const CutPlanApprovalDialog = ({ open, onClose, onSubmit, orderFlow, action, alerts = {}, alertReasons = {} }) => {
  const reasons = Object.keys(alertReasons).map(id => alertReasons[id]);
  let record = {};
  if ((action === "approve" || action === "reject") && orderFlow && orderFlow.orderConfig.alerts) {
    record = JSON.parse(orderFlow.orderConfig.alerts);
    record.cadRemarks = orderFlow.orderConfig.cadRemarks;
  }
  let title = action === "approve" ? "Approve Cut Plan" : action === "reject" ? "Reject Cut Plan" : "Send for Approval";
  return (
    <Dialog open={open} fullWidth={true} maxWidth="sm" onClose={onClose}>
      <DialogTitle> {title}</DialogTitle>
      <Divider />
      <DialogContent>
        <SimpleForm
          record={record}
          onSubmit={onSubmit}
          footer={props => (
            <PageFooter>
              <SaveButton {...props} label="Submit" />
              <Button label="Cancel" onClick={onClose} variant="contained">
                <ActionCancel />
              </Button>
            </PageFooter>
          )}>
          {alerts.lowCutPercent && action === "approve" && (
            <SelectArrayInput
              label="Reason for Low Cut Percent"
              source="lowCutPercent"
              choices={[
                ...reasons.filter(e => e.parameter === "lowCutPercent").map(e => ({ id: e.reason, name: e.reason })),
                { id: "Others", name: "Others" }
              ]}
              validate={required()}
              {...inputOptions(12)}
            />
          )}

          {alerts.lowMarkerEfficiency && (
            <SelectArrayInput
              label="Reason for Low Efficiency"
              source="lowMarkerEfficiency"
              choices={[
                ...reasons
                  .filter(e => e.parameter === "lowMarkerEfficiency")
                  .map(e => ({ id: e.reason, name: e.reason })),
                { id: "Others", name: "Others" }
              ]}
              validate={required()}
              disabled={action === "approve" || action === "reject"}
              {...inputOptions(12)}
            />
          )}

          {alerts.consumptionVariation && (
            <SelectArrayInput
              label="Reason for Consumption Variation"
              source="consumptionVariation"
              choices={[
                ...reasons
                  .filter(e => e.parameter === "consumptionVariation")
                  .map(e => ({ id: e.reason, name: e.reason })),
                { id: "Others", name: "Others" }
              ]}
              validate={required()}
              disabled={action === "approve" || action === "reject"}
              {...inputOptions(12)}
            />
          )}
          <TextInput
            label="CAD Remarks"
            source="cadRemarks"
            {...inputOptions(12)}
            disabled={action === "approve" || action === "reject"}
          />
          {(action === "approve" || action === "reject") && (
            <TextInput label="Merchant Remarks" source="merchantRemarks" {...inputOptions(12)} />
          )}
        </SimpleForm>
      </DialogContent>
    </Dialog>
  );
};

export default CutPlanApprovalDialog;
